import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { flash } from "@/lib/flash";

const PLACEHOLDER_PRODUCTS = [
  { id: "placeholder-1", title: "Shirts Coming Soon!", category: "Shirts", price: "34.99 - 59.99", image: null },
  { id: "placeholder-2", title: "Hats Coming Soon!", category: "Hats", price: "49.99", image: null },
  { id: "placeholder-3", title: "Hoodies Coming Soon!", category: "Hoodies", price: "59.99 - 79.99", image: null },
  { id: "placeholder-4", title: "Accessories Coming Soon!", category: "Accessories", price: "Not Even Sure What To Put Here Yet", image: null },
  { id: "placeholder-5", title: "Favorite Tech Items Coming Soon!", category: "Favorite Tech", price: "99.99 er sumthin'", image: null },
];


export function MerchWheel({
  products = [],
  setCart,
  region,
  backendUrl,
}) {





  console.log(
      "MERCH OPTIONS:",
      products[0]?.variants
          ?.filter(
              (variant) =>
                  variant.purchasable === true
          )
          .map((variant) => ({
              title: variant.title,
              option_values: variant.option_values,
          }))
  );
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});

  const [inventory, setInventory] = useState({
    key: null,
    status: "select_options",
    stock: 0,
    abundant: false,
  });

  const [inventoryRetry, setInventoryRetry] = useState(0);
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const hasProducts = products.length > 0;

  const displayProducts = hasProducts
      ? products
      : PLACEHOLDER_PRODUCTS;

  console.log(
      "MERCHWHEEL DESCRIPTION CHECK:",
      displayProducts.map((product) => ({
          title: product.title,
          short_description: product.short_description,
          description_length: product.description?.length,
          short_description_length: product.short_description?.length,
      }))
  );      

  const productCount = displayProducts.length;

  const activeProduct = displayProducts[activeIndex];
  const activePrice =
  region === "US"
    ? activeProduct?.price_usd
    : activeProduct?.price_cad;

  const purchasableVariants = (
      activeProduct?.variants || []
  ).filter(
      (variant) => variant.purchasable === true
  );

  const optionGroups = {};

  purchasableVariants.forEach((variant) => {
      (variant.option_values || []).forEach((option) => {
          if (!optionGroups[option.option_name]) {
              optionGroups[option.option_name] = new Set();
          }

          optionGroups[option.option_name].add(option.value);
      });
  });

  const availableOptions = Object.entries(optionGroups).map(
      ([name, values]) => ({
          name,
          values: [...values],
      })
  );

  // Find the exact variant matching the customer's selections.
  const hasCompleteSelection =
    availableOptions.length > 0 &&
    availableOptions.every(({ name }) => Boolean(selectedOptions[name]));

  const selectedVariant = hasCompleteSelection
    ? purchasableVariants.find((variant) =>
        Object.entries(selectedOptions).every(
          ([optionName, optionValue]) =>
            variant.option_values?.some(
              (option) =>
                option.option_name === optionName &&
                option.value === optionValue
            )
        )
      )
    : null;

  const selectedInventoryKey =
    region === "CA" && selectedVariant
      ? selectedVariant.inventory_sku ||
        selectedVariant.sku ||
        selectedVariant.id
      : null;

  // A result is valid only for the currently selected variant.
  const currentInventory =
    inventory.key === selectedInventoryKey && selectedInventoryKey
      ? inventory
      : {
          status: selectedVariant ? "checking" : "select_options",
          stock: 0,
          abundant: false,
        };

  useEffect(() => {
    if (
      region !== "CA" ||
      !selectedVariant ||
      !activeProduct?.id
    ) {
      return;
    }

    const controller = new AbortController();
    const key =
      selectedVariant.inventory_sku ||
      selectedVariant.sku ||
      selectedVariant.id;
    const baseUrl = (backendUrl || "").replace(/\/$/, "");

    setInventory({
      key,
      status: "checking",
      stock: 0,
      abundant: false,
    });

    async function checkInventory() {
      try {
        const params = new URLSearchParams({
          product_id: activeProduct.id,
          variant_id: selectedVariant.id,
        });

        const response = await fetch(
          `${baseUrl}/api/merch/stock?${params}`,
          { signal: controller.signal }
        );

        if (!response.ok) {
          throw new Error("Inventory verification failed");
        }

        const data = await response.json();

        if (controller.signal.aborted) return;

        setInventory({
          key,
          status: data.available ? "available" : "out_of_stock",
          stock: Number(data.stock) || 0,
          abundant: data.abundant === true,
        });
      } catch (error) {
        if (controller.signal.aborted) return;

        console.error("Merch inventory check failed:", error);

        setInventory({
          key,
          status: "error",
          stock: 0,
          abundant: false,
        });
      }
    }

    checkInventory();

    return () => controller.abort();
  }, [
    activeProduct?.id,
    selectedVariant,
    region,
    backendUrl,
    inventoryRetry,
  ]);

  // Resolve the selected shirt color to its advertising image key.
  const selectedColorValue =
    Object.entries(selectedOptions).find(([name]) =>
      name.toLowerCase().includes("color")
    )?.[1] ??
    availableOptions.find(({ name }) =>
      name.toLowerCase().includes("color")
    )?.values[0];

  const advertisingColorByValue = {
    white: "WHT",
    black: "BLK",
    "sport grey": "GREY",
    "sport gray": "GREY",
    grey: "GREY",
    gray: "GREY",
  };

  const advertisingColor =
    advertisingColorByValue[
      String(selectedColorValue ?? "").trim().toLowerCase()
    ];

  const apiBase = (backendUrl || "").replace(/\/$/, "");
  const regionKey = region === "US" ? "US" : "CA";

  const productDisplayImage = (() => {
    const imageUrl =
      activeProduct?.advertising_images?.[advertisingColor]?.[regionKey];

    if (!imageUrl) return null;

    return /^https?:\/\//i.test(imageUrl)
      ? imageUrl
      : `${apiBase}${imageUrl.startsWith("/") ? "" : "/"}${imageUrl}`;
  })();


  console.log(
      "AVAILABLE OPTIONS:",
      JSON.stringify(
          availableOptions,
          null,
          2
      )
  );


  console.log("ADVERTISING IMAGE DEBUG:", {
    productId: activeProduct?.id,
    productTitle: activeProduct?.title,
    selectedColorValue,
    advertisingColor,
    backendUrl,
    region,
    productDisplayImage,
  });


  console.log(
    "RENDERING OPTIONS:",
    JSON.stringify(
        availableOptions,
        null,
        2
    )
  );


const navigate = useNavigate();

const handleViewCart = () => {
  navigate("/coming-soon");
};

  const normalizeIndex = useCallback(
    (index) => {
      if (!productCount) return 0;
      return ((index % productCount) + productCount) % productCount;
    },
    [productCount]
  );

  const moveWheel = useCallback(
    (direction) => {
      if (!productCount || isAnimating) return;

      // Each design starts with a fresh color/size selection.
      setSelectedOptions({});

      setInventory({
        key: null,
        status: "select_options",
        stock: 0,
        abundant: false,
      });

      setIsAnimating(true);
      setActiveIndex((current) =>
        normalizeIndex(current + direction)
      );
      window.setTimeout(() => {
        setIsAnimating(false);
      }, 500);
    },
    [isAnimating, normalizeIndex, productCount]
  );

  const next = useCallback(() => {
    moveWheel(1);
  }, [moveWheel]);

  const previous = useCallback(() => {
    moveWheel(-1);
  }, [moveWheel]);

  /*
   * Keyboard navigation
   */
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "ArrowLeft") {
        previous();
      }
      if (event.key === "ArrowRight") {
        next();
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [next, previous]);

  /*
   * Touch / swipe navigation
   */
  useEffect(() => {
    const element = document.getElementById("merch-wheel");
    if (!element) return;

    let touchStartX = 0;
    let touchStartY = 0;

    function handleTouchStart(event) {
      const touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }

    function handleTouchEnd(event) {
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      /*
       * Ignore mostly vertical gestures.
       */
      if (Math.abs(deltaX) < Math.abs(deltaY)) return;
      if (Math.abs(deltaX) < 45) return;

      if (deltaX < 0) {
        next();
      } else {
        previous();
      }
    }

    element.addEventListener("touchstart", handleTouchStart, {
      passive: true,
    });

    element.addEventListener("touchend", handleTouchEnd, {
      passive: true,
    });

    return () => {
      element.removeEventListener(
        "touchstart",
        handleTouchStart
      );
      element.removeEventListener("touchend", handleTouchEnd);
    };
  }, [next, previous]);

  const getRelativePosition = (index) => {
    let difference = index - activeIndex;

    if (difference > productCount / 2) {
      difference -= productCount;
    }

    if (difference < -productCount / 2) {
      difference += productCount;
    }

    return difference;
  };

  const getCardStyle = (relativePosition) => {
    /*
     * Center product
     */
    if (relativePosition === 0) {
      return {
        transform:
          "translateX(-50%) translateZ(120px) rotateY(0deg) scale(1)",
        opacity: 1,
        zIndex: 30,
        filter: "blur(0px)",
      };
    }

    /*
     * Immediate previous / next products.
     */
    if (relativePosition === -1) {
      return {
        transform:
          "translateX(-50%) translateX(-230px) translateZ(-80px) rotateY(38deg) scale(0.72)",
        opacity: 0.65,
        zIndex: 20,
        filter: "blur(0.3px)",
      };
    }

    if (relativePosition === 1) {
      return {
        transform:
          "translateX(-50%) translateX(230px) translateZ(-80px) rotateY(-38deg) scale(0.72)",
        opacity: 0.65,
        zIndex: 20,
        filter: "blur(0.3px)",
      };
    }

    /*
     * Far left.
     */
    if (relativePosition < -1) {
      return {
        transform:
          "translateX(-50%) translateX(-390px) translateZ(-260px) rotateY(58deg) scale(0.45)",
        opacity: 0.2,
        zIndex: 10,
        filter: "blur(2px)",
      };
    }

    /*
     * Far right.
     */
    return {
      transform:
        "translateX(-50%) translateX(390px) translateZ(-260px) rotateY(-58deg) scale(0.45)",
      opacity: 0.2,
      zIndex: 10,
      filter: "blur(2px)",
    };
  };

  return (
    <div
      id="merch-wheel"
      className="
        relative
        h-[700px]
        sm:h-[575px]
        w-full
        overflow-hidden
        border
        border-matrix-green/20
        bg-black/50
        select-none
      "
    >
      {/* Ambient glow */}
      <div
        className="
          pointer-events-none
          absolute
          left-1/2
          top-1/2
          z-0
          h-[420px]
          w-[420px]
          -translate-x-1/2
          -translate-y-1/2
          rounded-full
          bg-matrix-green/[0.04]
          blur-[100px]
        "
      />

      {/* Top HUD */}
      <div
        className="
          absolute
          left-0
          right-0
          top-0
          z-40
          flex
          items-center
          justify-between
          border-b
          border-matrix-green/10
          bg-black/30
          px-5
          py-3
          backdrop-blur-sm
        "
      >
        <span
          className="
            font-mono
            text-[9px]
            uppercase
            tracking-[0.25em]
            text-matrix-green/60
          "
        >
          Comik Releaf // Select
        </span>

        <span
          className="
            font-mono
            text-[9px]
            uppercase
            tracking-[0.2em]
            text-white/25
          "
        >
          {String(activeIndex + 1).padStart(2, "0")} /{" "}
          {String(productCount).padStart(2, "0")}
        </span>
      </div>

      {/* Wheel */}
      <div
        className="
          relative
          flex
          h-[335px]
          w-full
          items-start
          justify-center
          [perspective:1200px]
        "
      >
        <div
          className="
            relative
            h-[135px]
            w-full
            [transform-style:preserve-3d]
          "
        >
          {displayProducts.map((product, index) => {
            const relativePosition = getRelativePosition(index);

            /*
             * Don't render products that are too far away.
             * This keeps the DOM light if the catalogue becomes large.
             */
            if (Math.abs(relativePosition) > 2) {
              return null;
            }


            const isActive = relativePosition === 0;

            const cardColor = isActive ? advertisingColor : "WHT";

            const cardImageUrl =
              product.advertising_images?.[cardColor]?.[regionKey];

            const cardImage = cardImageUrl
              ? /^https?:\/\//i.test(cardImageUrl)
                ? cardImageUrl
                : `${apiBase}${cardImageUrl.startsWith("/") ? "" : "/"}${cardImageUrl}`
              : null;

            return (

              <article
                key={product.id}
                className="
                  absolute
                  left-1/2
                  top-1/2
                  w-[230px]
                  -translate-y-1/2
                  transition-all
                  duration-500
                  ease-[cubic-bezier(0.22,1,0.36,1)]
                  will-change-transform
                "
                style={{
                  ...getCardStyle(relativePosition),
                  transformOrigin: "center center",
                }}
              >
                <div
                  className={`
                    relative
                    overflow-hidden
                    border
                    bg-black
                    transition-all
                    duration-500
                    ${
                      isActive
                        ? `
                          border-matrix-green/60
                          shadow-[0_0_40px_rgba(0,255,100,0.12)]
                        `
                        : `
                          border-white/10
                          shadow-none
                        `
                    }
                  `}
                >
                  {/* Corner markers */}
                  {isActive && (
                    <>
                      <div className="absolute left-2 top-2 z-20 h-3 w-3 border-l border-t border-matrix-green" />
                      <div className="absolute right-2 top-2 z-20 h-3 w-3 border-r border-t border-matrix-green" />
                      <div className="absolute bottom-2 left-2 z-20 h-3 w-3 border-b border-l border-matrix-green" />
                      <div className="absolute bottom-2 right-2 z-20 h-3 w-3 border-b border-r border-matrix-green" />
                    </>
                  )}

                  <div className="aspect-square overflow-hidden bg-white/[0.03]">

                    {cardImage ? (
                      <img
                        src={cardImage}
                        alt={product.title}
                        draggable="false"
                        className={`
                          h-full
                          w-full
                          object-cover
                          transition-transform
                          duration-700
                          ${
                            isActive
                              ? "scale-100"
                              : "scale-105"
                          }
                        `}
                      />
                    ) : (
                      <div className="flex h-full w-full items-center justify-center bg-black/40">
                        <span className="px-3 text-center font-mono text-[9px] uppercase tracking-widest text-matrix-green/40">
                          Mockup Coming Soon
                        </span>
                      </div>
                    )}


                    {/* Image scanline */}
                    <div
                      className="
                        pointer-events-none
                        absolute
                        inset-0
                        bg-[linear-gradient(to_bottom,transparent_50%,rgba(0,255,100,0.025)_50%)]
                        bg-[length:100%_4px]
                      "
                    />

                    {/* Green overlay */}
                    {isActive && (
                      <div
                        className="
                          pointer-events-none
                          absolute
                          inset-0
                          bg-gradient-to-t
                          from-matrix-green/[0.08]
                          via-transparent
                          to-transparent
                        "
                      />
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>

      {/* Navigation arrows */}
      <button
        type="button"
        onClick={previous}
        disabled={isAnimating}
        aria-label="Previous product"
        className="
          absolute
          left-4
          top-[187.5px]
          z-50
          flex
          h-12
          w-12
          -translate-y-1/2
          items-center
          justify-center
          border
          border-matrix-green/30
          bg-black/60
          font-mono
          text-xl
          text-matrix-green
          backdrop-blur-sm
          transition-all
          duration-200
          hover:border-matrix-green
          hover:bg-matrix-green/10
          hover:shadow-[0_0_20px_rgba(0,255,100,0.15)]
          disabled:cursor-not-allowed
          disabled:opacity-40
        "
      >
        ←
      </button>

      <button
        type="button"
        onClick={next}
        disabled={isAnimating}
        aria-label="Next product"
        className="
          absolute
          right-4
          top-[187.5px]
          z-50
          flex
          h-12
          w-12
          -translate-y-1/2
          items-center
          justify-center
          border
          border-matrix-green/30
          bg-black/60
          font-mono
          text-xl
          text-matrix-green
          backdrop-blur-sm
          transition-all
          duration-200
          hover:border-matrix-green
          hover:bg-matrix-green/10
          hover:shadow-[0_0_20px_rgba(0,255,100,0.15)]
          disabled:cursor-not-allowed
          disabled:opacity-40
        "
      >
        →
      </button>

      {/* Active product information */}
      <div
        className="
          relative
          z-40
          mx-auto
          flex
          h-[255px]
          max-w-xl
          flex-col
          px-6
          pb-8
        "
      >
        {/* Product information */}
        <div className="text-center">


          <h3
            className="
              mt-2
              font-display
              text-2xl
              font-black
              uppercase
              tracking-wide
              text-white
            "
          >
            {displayProducts[activeIndex]?.title}
          </h3>

          {(
            displayProducts[activeIndex]?.short_description ||
            displayProducts[activeIndex]?.description
          ) && (
            <p
              className="
                mx-auto
                mt-2
                max-w-md
                font-mono
                text-[10px]
                leading-relaxed
                text-white/35
              "
            >
              {displayProducts[activeIndex]?.short_description ||
                displayProducts[activeIndex]?.description}
            </p>
          )}

        </div>

         {/* Purchase area */}
        <div className="mt-auto">
          <div
            className="
              mt-2
              text-center
              font-mono
              text-sm
              font-bold
              text-matrix-green
            "
          >
            {activePrice != null
              ? `$${Number(activePrice).toFixed(2)} ${region === "US" ? "USD" : "CAD"}`
              : "—"}
          </div>

          <div className="mt-4">
            {/* Purchase controls */}
            <div className="mx-auto flex w-full max-w-xl flex-col items-stretch justify-center gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-4">
              {availableOptions.map(
                  ({ name, values }) => (
                    <div
                        key={name}
                        className="flex w-full items-center justify-center gap-1.5 sm:w-auto"
                    >
                          {values.map((value) => (
                              <button
                                  key={value}
                                  type="button"
                                  onClick={() =>
                                      setSelectedOptions(
                                          (current) => ({
                                              ...current,
                                              [name]: value,
                                          })
                                      )
                                  }
                                  className={`
                                      border
                                      px-3
                                      py-2
                                      font-mono
                                      text-[8px]
                                      font-bold
                                      transition-all
                                      duration-200
                                      ${
                                          selectedOptions[name] === value
                                              ? `
                                                  border-matrix-green
                                                  bg-matrix-green/15
                                                  text-matrix-green
                                                  shadow-[0_0_12px_rgba(0,255,100,0.12)]
                                              `
                                              : `
                                                  border-matrix-green/20
                                                  bg-black/50
                                                  text-white/60
                                                  hover:border-matrix-green/60
                                                  hover:bg-matrix-green/10
                                                  hover:text-matrix-green
                                              `
                                      }
                                  `}
                              >
                                  {value}
                              </button>
                          ))}
                      </div>
                  )
              )}

              {/* Cart actions */}
              <div className="flex w-full flex-row items-center justify-center gap-2">
                {/* Add to Cart */}
                <div className="relative inline-flex flex-none">
                  {/* Heavenly energy layer */}
                  <svg
                    className="pointer-events-none absolute inset-0 z-20 h-full w-full overflow-visible"
                    viewBox="0 0 100 40"
                    preserveAspectRatio="none"
                  >
                    <defs>
                      <filter
                        id="cartOrbGlow"
                        x="-200%"
                        y="-200%"
                        width="400%"
                        height="400%"
                      >
                        <feGaussianBlur
                          stdDeviation="2"
                          result="blur1"
                        />
                        <feGaussianBlur
                          stdDeviation="5"
                          result="blur2"
                        />
                        <feMerge>
                          <feMergeNode in="blur2" />
                          <feMergeNode in="blur1" />
                          <feMergeNode in="SourceGraphic" />
                        </feMerge>
                      </filter>

                      <path
                        id="cartOrbPath"
                        d="
                          M 10 1
                          H 90
                          V 39
                          H 10
                          Z
                        "
                        fill="none"
                      />
                    </defs>

                    {/* Soft heavenly trail */}
                    <circle
                      r="12"
                      fill="#fff8d6"
                      opacity="0.16"
                      filter="url(#cartOrbGlow)"
                    >
                      <animateMotion
                        dur=".36s"
                        repeatCount="indefinite"
                        rotate="auto"
                      >
                        <mpath href="#cartOrbPath" />
                      </animateMotion>
                    </circle>

                    {/* Main heavenly sphere */}
                    <circle
                      r="2.8"
                      fill="#fffdf0"
                      filter="url(#cartOrbGlow)"
                    >
                      <animateMotion
                        dur=".35s"
                        repeatCount="indefinite"
                        rotate="auto"
                      >
                        <mpath href="#cartOrbPath" />
                      </animateMotion>
                    </circle>
                  </svg>

                <button
                    type="button"
                    disabled={
                      isAddingToCart ||
                      (region === "CA" &&
                        (!selectedVariant ||
                          currentInventory.status === "checking" ||
                          currentInventory.status === "out_of_stock"))
                    }
                    onClick={() => {
                        if (!selectedVariant) {
                            flash("Please Select A Color And Size");
                            return;
                        }

                        if (region === "CA") {
                            if (currentInventory.status === "error") {
                                setInventoryRetry((current) => current + 1);
                                return;
                            }

                            if (
                                currentInventory.status !== "available" ||
                                currentInventory.key !== selectedInventoryKey
                            ) {
                                flash("Please Wait For Stock Verification");
                                return;
                            }
                        }

                        const cartItem = {
                            id: `${activeProduct.id}-${selectedVariant.id}`,
                            productId: activeProduct.id,
                            variantId: selectedVariant.id,
                            sku: selectedVariant.sku,
                            inventory_sku: selectedVariant.inventory_sku,
                            title: activeProduct.title,
                            image: productDisplayImage,
                            variant: selectedVariant.title,
                            price: Number(
                                region === "US"
                                  ? activeProduct.price_usd
                                  : activeProduct.price_cad
                            ),
                            quantity: 1,
                        };

                        setIsAddingToCart(true);

                        setCart((currentCart) => {
                          const existingQuantity = currentCart.reduce(
                              (total, item) => {
                                  const sameGarment =
                                      selectedVariant.inventory_sku && item.inventory_sku
                                          ? item.inventory_sku === selectedVariant.inventory_sku
                                          : item.variantId === selectedVariant.id;

                                  return sameGarment
                                      ? total + Number(item.quantity || 1)
                                      : total;
                              },
                              0
                          );

                            if (
                                region === "CA" &&
                                !currentInventory.abundant &&
                                existingQuantity >= currentInventory.stock
                            ) {
                                flash("Maximum Available Quantity Reached");
                                return currentCart;
                            }

                            return [...currentCart, cartItem];
                        });

                        setIsAddingToCart(false);
                        flash("Cart Updated");
                    }}
                    className="
                      relative
                      z-10
                      inline-flex
                      items-center
                      justify-center
                      whitespace-nowrap
                      rounded-full
                      border
                      border-matrix-green/70
                      bg-matrix-green/[0.10]
                      px-5
                      py-2
                      font-mono
                      text-[8px]
                      font-bold
                      uppercase
                      tracking-wider
                      text-white
                      shadow-[0_0_12px_rgba(0,255,136,0.10)]
                      transition-all
                      duration-300
                      hover:border-matrix-green
                      hover:bg-matrix-green/[0.16]
                      hover:shadow-[0_0_18px_rgba(0,255,136,0.18)]
                    "
                  >
                    {region === "CA"
                      ? !selectedVariant
                        ? "SELECT OPTIONS"
                        : currentInventory.status === "checking"
                          ? "CHECKING STOCK..."
                          : currentInventory.status === "out_of_stock"
                            ? "SOLD OUT"
                            : currentInventory.status === "error"
                              ? "TRY AGAIN"
                              : currentInventory.status === "available"
                                ? "ADD TO CART"
                                : "SELECT OPTIONS"
                      : "ADD TO CART"}
                  </button>
                </div>

                {/* View Cart */}
                <button
                  type="button"
                  onClick={handleViewCart}
                  className="
                    inline-flex
                    flex-none
                    items-center
                    justify-center
                    rounded-full
                    border
                    border-matrix-green/70
                    bg-matrix-green/[0.10]
                    px-6
                    py-2
                    font-mono
                    text-[8px]
                    font-bold
                    uppercase
                    tracking-wider
                    text-white
                    shadow-[0_0_12px_rgba(0,255,136,0.10)]
                    transition-all
                    duration-300
                    hover:border-matrix-green
                    hover:bg-matrix-green/[0.16]
                    hover:shadow-[0_0_18px_rgba(0,255,136,0.18)]
                  "
                >
                  VIEW CART
                </button>
              </div>
            </div>
          </div>

          {/* Payment / trust indicators */}
          <div
            className="
              mx-auto
              mt-3
              flex
              max-w-md
              items-center
              justify-center
              gap-4
              border-t
              border-matrix-green/10
              pt-4
              font-mono
              text-[8px]
              font-bold
              uppercase
              tracking-[0.12em]
              text-white/25
            "
          >
            <span>PayPal</span>
            <span className="text-matrix-green/20">•</span>
            <span>Stripe</span>
            <span className="text-matrix-green/20">•</span>
            <span>VISA</span>
            <span className="text-matrix-green/20">•</span>
            <span>Mastercard</span>
          </div>
        </div>
      </div>
    </div>
  );

}

export default MerchWheel;